import { useEffect } from "react"
import { useTranslation } from "react-i18next"
import { NavLink, useNavigate } from "react-router-dom"

const redirectTime = 10

const SuccessPaymentPage = () => {
  const {t} = useTranslation()
  const navigate = useNavigate()
  useEffect(() => {    
    setTimeout(() => {
      navigate('/shipment-bills')
    }, redirectTime * 1000)

  }, [navigate])
  return (
    <div className="flex flex-col items-center gap-10">
      <div className="text-3xl font-bold text-emerald-700">
        {t("success_payment_page.payment_success")}
      </div>
      <div>
        <img src="/static/images/png/green_circle_checkmark.png" alt="green checkmark" width={150} height={150}/>
      </div>
        <div href="/" className="text-emerald-700 font-light">
          {t("success_payment_page.redirect_message")} {" "}
          {redirectTime} {" "}
          {t("success_payment_page.seconds")}
          </div>
      <div>
        <NavLink 
          to="/shipment-bills" 
          className="text-blue-500 hover:text-blue-700 font-medium"
        >{t("success_payment_page.go_to_bills")}</NavLink>
      </div>
    </div>

  )
}

export default SuccessPaymentPage